import store from "../../store/store"

export const getUserInviteSettings = () => {
    const userInviteSettings = store?.getState().project.userInviteSettings.data

    const internalUserRefEnabled = userInviteSettings?.InternalUserCT
    const isAppealToAdEnabled = userInviteSettings?.AppealToAD

    return { isAppealToAdEnabled, internalUserRefEnabled }
}
